// extracted by mini-css-extract-plugin
export default {"content":"vIul6BEVYeNKshRgxP4T","col":"wdEFTKFr6tzhviRaocSO"};